import * as React from 'react';
export const CCSvg = React.forwardRef(function CCSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#24B47E',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M10 3.357a2.333 2.333 0 1 0 0 4.619 2.666 2.666 0 1 1 0-4.619ZM10.5 6a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm3-3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm1 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-10-6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z',
      }),
    ),
  );
});
CCSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var CC = {
  category: 'flag',
  colorable: false,
  name: 'CC',
  svg: CCSvg,
};
